import { createSlice } from "@reduxjs/toolkit";
import {
  addStudentForSchool,
  deleteStudent,
  getStudentsForSchool,
  getStudentsForSection,
  searchStudent,
  editStudent,
  showGradesForAllMaterials,
  addNewGrade,
  getStudentsForParent,
  getAllStudents,
  getStudentPayments,
  deleteStudentPayment,
  addStudentPayment,
  addPointsForStudents,
  deleteGrade,
  addPointsToStudent,
} from "../services/student_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "student",

  initialState: {
    isLoadingStudentsForSchool: false,
    isLoadingAddStudentForSchool: false,
    isLoadingDeleteStudent: false,
    students: {},
    allStudentsForSchool: {},
    isLoadingGradeForStudents: false,
    isLoadingGetStudentsForSection: false,
    studentsForSection: {},
    receiveNotes: [],
    sendingNotes: [],
    studentInfo: "",
    isLoadingSearchStudent: false,
    searchedStudents: null,
    getStudentBySearch: false,
    studentId: "",
    isLoadingShowGrades: false,
    gradesForAllMaterials: [],
    isLoadingAddNewGrade: [],
    isLoadingGetStudentsForParent: false,
    familyStudents: [],
    isLoadingGetAllStudents: false,
    allStudents: [],
    isLoadingGetStudentPayments: false,
    studentPayment: {},
    isLoadingDeleteStudentPayments: false,
    isLoadingAddStudentPayments: false,
    studentPageNumber: 1,
    isLoadingAddPointsForStudents: false,
    isLoadingDeleteGrade: false,
    last_season: 1,
  },

  reducers: {
    setStudentInfo: (state, action) => {
      state.studentInfo = action.payload;
    },
    toggleGetStudentBySearch: (state, action) => {
      state.getStudentBySearch = action.payload;
    },
    setStudentPageNumber: (state, action) => {
      state.studentPageNumber = action.payload;
    },
    setLastSeason: (state, action) => {
      state.last_season = action.payload;
    },
  },

  extraReducers: {
    //GET  ==> get StudentsForSchool
    [getStudentsForSchool.fulfilled]: (state, action) => {
      state.isLoadingStudentsForSchool = false;
      state.students = action.payload.data.data;
      state.allStudentsForSchool = action.payload.data;
    },
    [getStudentsForSchool.rejected]: (state, action) => {
      state.isLoadingStudentsForSchool = false;
    },
    [getStudentsForSchool.pending]: (state) => {
      state.isLoadingStudentsForSchool = true;
    },

    // POST  ==> get addStudentForSchool
    [addStudentForSchool.fulfilled]: (state, action) => {
      state.isLoadingAddStudentForSchool = false;
      state.newStudentInfo = action.payload.data;
      if (action.payload.message === "Added Successfully") {
        window.location.href = "/dashboard/families";
      }
    },
    [addStudentForSchool.rejected]: (state, action) => {
      state.isLoadingAddStudentForSchool = false;
    },
    [addStudentForSchool.pending]: (state) => {
      state.isLoadingAddStudentForSchool = true;
    },

    // DELETE  ==> deleteStudent
    [deleteStudent.fulfilled]: (state, action) => {
      state.isLoadingDeleteStudent = false;
      if (action.payload.message === "Deleted Successfully") {
        window.location.href = "/dashboard/students";
      }
    },
    [deleteStudent.rejected]: (state, action) => {
      state.isLoadingDeleteStudent = false;
    },
    [deleteStudent.pending]: (state) => {
      state.isLoadingDeleteStudent = true;
    },

    // GET  ==> getStudentsForSection
    [getStudentsForSection.fulfilled]: (state, action) => {
      state.isLoadingGetStudentsForSection = false;
      state.studentsForSection = action.payload.data;
      // if (action.payload.message === 'Student deleted successfully') {

      // }
    },
    [getStudentsForSection.rejected]: (state, action) => {
      state.isLoadingGetStudentsForSection = false;
    },
    [getStudentsForSection.pending]: (state) => {
      state.isLoadingGetStudentsForSection = true;
    },

    // GET  ==> searchStudent
    [searchStudent.fulfilled]: (state, action) => {
      state.isLoadingSearchStudent = false;
      state.searchedStudents = action.payload.data;
    },
    [searchStudent.rejected]: (state, action) => {
      state.isLoadingSearchStudent = false;
    },
    [searchStudent.pending]: (state) => {
      state.isLoadingSearchStudent = true;
    },

    // Post  ==> editStudent
    [editStudent.fulfilled]: (state, action) => {
      state.isLoadingEditStudent = false;
    },
    [editStudent.rejected]: (state, action) => {
      state.isLoadingEditStudent = false;
    },
    [editStudent.pending]: (state) => {
      state.isLoadingEditStudent = true;
    },

    // get showGradesForAllMaterials
    [showGradesForAllMaterials.fulfilled]: (state, action) => {
      state.isLoadingShowGrades = false;
      state.gradesForAllMaterials = action.payload.data;
    },
    [showGradesForAllMaterials.rejected]: (state, action) => {
      state.isLoadingShowGrades = false;
    },
    [showGradesForAllMaterials.pending]: (state) => {
      state.isLoadingShowGrades = true;
    },

    // addNewGrade
    [addNewGrade.fulfilled]: (state, action) => {
      state.isLoadingAddNewGrade = false;
      if (
        action.payload.message === "Added Successfully" ||
        action.payload.message === "تمت الإضافة بنجاح"
      ) {
        alert(action.payload.message);
        window.location.href = "/dashboard/students/grades";
      }
    },
    [addNewGrade.rejected]: (state, action) => {
      state.isLoadingAddNewGrade = false;
    },
    [addNewGrade.pending]: (state) => {
      state.isLoadingAddNewGrade = true;
    },

    // getStudentsForParent
    [getStudentsForParent.fulfilled]: (state, action) => {
      state.isLoadingGetStudentsForParent = false;
      state.familyStudents = action.payload.data;
      // if (action.payload.message === "Added Successfully"
      //   || action.payload.message === "تمت الإضافة بنجاح"
      // ) {
      //   alert(action.payload.message)
      //   window.location.href = '/dashboard/students/grades'
      // }
    },
    [getStudentsForParent.rejected]: (state, action) => {
      state.isLoadingGetStudentsForParent = false;
    },
    [getStudentsForParent.pending]: (state) => {
      state.isLoadingGetStudentsForParent = true;
    },

    // get All Students
    [getAllStudents.fulfilled]: (state, action) => {
      state.isLoadingGetAllStudents = false;
      state.allStudents = action.payload.data;
    },
    [getAllStudents.rejected]: (state, action) => {
      state.isLoadingGetAllStudents = false;
    },
    [getAllStudents.pending]: (state) => {
      state.isLoadingGetAllStudents = true;
    },

    // get Student Payments
    [getStudentPayments.fulfilled]: (state, action) => {
      state.isLoadingGetStudentPayments = false;
      state.studentPayment = action.payload.data;
    },
    [getStudentPayments.rejected]: (state, action) => {
      state.isLoadingGetStudentPayments = false;
    },
    [getStudentPayments.pending]: (state) => {
      state.isLoadingGetStudentPayments = true;
    },

    // delete Student Payment
    [deleteStudentPayment.fulfilled]: (state, action) => {
      state.isLoadingDeleteStudentPayments = false;
    },
    [deleteStudentPayment.rejected]: (state, action) => {
      state.isLoadingDeleteStudentPayments = false;
    },
    [deleteStudentPayment.pending]: (state) => {
      state.isLoadingDeleteStudentPayments = true;
    },

    // add Student Payment
    [addStudentPayment.fulfilled]: (state, action) => {
      state.isLoadingAddStudentPayments = false;
    },
    [addStudentPayment.rejected]: (state, action) => {
      state.isLoadingAddStudentPayments = false;
    },
    [addStudentPayment.pending]: (state) => {
      state.isLoadingAddStudentPayments = true;
    },

    // Post ==> addPointsForSectionStudents
    [addPointsForStudents.fulfilled]: (state, action) => {
      state.isLoadingAddPointsForStudents = false;
      // state.sectionsForClass = action.payload.data.data
    },
    [addPointsForStudents.rejected]: (state, action) => {
      state.isLoadingAddPointsForStudents = false;
    },
    [addPointsForStudents.pending]: (state) => {
      state.isLoadingAddPointsForStudents = true;
    },

    // Post ==> Delete Grade
    [deleteGrade.fulfilled]: (state, action) => {
      state.isLoadingDeleteGrade = false;
    },
    [deleteGrade.rejected]: (state, action) => {
      state.isLoadingDeleteGrade = false;
    },
    [deleteGrade.pending]: (state) => {
      state.isLoadingDeleteGrade = true;
    },

    // addPointsToStudent

    [addPointsToStudent.fulfilled]: (state, action) => {
      state.isLoadingDeleteGrade = false;
    },
    [addPointsToStudent.rejected]: (state, action) => {
      state.isLoadingDeleteGrade = false;
    },
    [addPointsToStudent.pending]: (state) => {
      state.isLoadingDeleteGrade = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  setStudentInfo,
  toggleGetStudentBySearch,
  setStudentPageNumber,
  setLastSeason,
} = slice.actions;
